// src/styles/base/band.ts
/**
 * The band under the app bar (Dashboard filters, Overview's date control) and the controls
 * that sit on it. Shared so every control on the band follows the band's roles in tokens.ts,
 * whichever colour the band is.
 */
import { colors } from './tokens';

/** The band itself */
export const bandSx = {
    backgroundColor: colors.band,
    color: colors.bandText,
    borderBottom: `1px solid ${colors.bandRule}`,
} as const;

/** A square outlined icon button on the band (export, analyse, optimise) */
export const bandIconButtonSx = {
    bgcolor: 'transparent',
    color: colors.bandText,
    border: `1px solid ${colors.bandLine}`,
    borderRadius: 0,
    height: '32px',
    width: '32px',
    '&:hover': { bgcolor: colors.bandHover },
    '&.Mui-disabled': { bgcolor: 'transparent', color: colors.bandDisabled },
} as const;

/** One half of a segmented toggle on the band */
export const bandToggleSx = (selected: boolean) =>
    ({
        bgcolor: selected ? colors.bandSelected : 'transparent',
        color: selected ? colors.bandSelectedText : colors.bandText,
        '&:hover': { bgcolor: selected ? colors.bandSelected : colors.bandHover },
    }) as const;

/** A thin upright divider between groups of band controls */
export const bandDividerSx = { width: '1px', height: '24px', bgcolor: colors.bandLine } as const;
